import { render } from "./headerChild.vue?vue&type=template&id=721b6a64"
import script from "./headerChild.vue?vue&type=script&lang=ts"
export * from "./headerChild.vue?vue&type=script&lang=ts"
script.render = render

export default script